import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class CategoriaService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    create(data: any)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/categoria`, data, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/categoria/${id}`, {headers : this.account.composeHeaders()});
    }

    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/categoria/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/categoria/${id}`, {headers : this.account.composeHeaders()});
    }

    list(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/categorias`, {headers : this.account.composeHeaders()});
    }

    isUniqueNomeCategoria(nome: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/nome-categoria-is-unique`, {nome},
        {headers : this.account.composeHeaders()});
    }


}
